function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagSI(props) {
  return /*#__PURE__*/React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURf39/Qg+p/j4+AlCrtcwKt01L+M5Mw5HtEp0w7PC4uLn7zj5yxEAAAFXSURBVDjL1U6hbsMwELX8BbX8A1bQVNQowIMFCS+wjUtcPCmgxR0aLdpoSNW/3Ls7r+2kxhoo2fP57t2750uU+g9wzmnltEaiVlMU5qQlh3aNxgFcwy16khw8rsjk0OLkhiUUhTFLN2hXnnBVTR1Xw+Vrqho+x+5wqhn2wHHOMOGMwFHoEocJvrm8bvB+9DMbOsHH5b17hJXy3nej91Nz9jdA6UbGW9lwaKaXmQ1SX5dN3bCfpnPVUPnJVmA7+wjtShXSGkqdcPiRidiFMshGthgh5QFHu1CWZINkSKKKjGpZog0MKxYa0ry1IlojBmt+ob3jPxtm8QzDro7t8wwZJ+040QVNxRBjTCnmFHcpZ9AUqcPNkbBVJMXSZ+EUmbWcNyrW8RfDEIeACEwoR5GIh7hWfQhhGDCiIre/shDWauh7BKWhD3wx58yxUWUuuKMF+EQdTzB8A6kdE6Q+QWmBAAAAAElFTkSuQmCC",
    alt: "SI"
  }, props));
}